import { Dispatch } from 'redux'
import { Action } from '../actions/dashboardActions'
import { DashboardActionType } from 'state/action-types/dashboardTypes'
import { DashboardFilters, OperationalDashboard } from 'interfaces/dashboards'

export const getOperationalDashboard = (data: OperationalDashboard) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: DashboardActionType.GET_OPERATIONAL_DASHBOARD,
            payload: data
        })
    }
}

export const setDashboardFilters = (data: DashboardFilters) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: DashboardActionType.SET_DASHBOARD_FILTER,
            payload: data
        })
    }
}